<template>
  <DashboardLayout>

    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <p class="mb-0 main-identifier fw-semibold">MDA</p>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">Create MDA</p>
    </div>

    <div class="d-flex justify-content-center">
      <div class="form-outer">
        <form @submit.prevent="handleSubmit">
          <div class="crud-form position-relative">

            <div class="form-inner">

              <div class="form-header d-flex justify-content-between align-items-center">
                <h1 class="mb-0">MDA</h1>
              </div>

              <div class="form-body">
                <div class="row mt-2 mb-3">
                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="name"
                        class="form-label">Name</label></div>
                    <div class="col-md-9 input-right"><input type="text" class="form-control" v-model="mdaName"
                        placeholder="Enter MDA Name" required></div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label
                        for="organizationCode" class="form-label">Organization Code</label></div>
                    <div class="col-md-9 input-right"><input type="text" class="form-control" v-model="organizationCode"
                        placeholder="Enter Organization Code" required></div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label
                        for="subsector" class="form-label">Sub-sector</label></div>
                    <div class="col-md-9 input-right">
                      <select class="form-select" v-model="subSectorId" @change="checkAddNewSubsector" required>
                        <option value="" disabled>- Select Sub-sector -</option>
                        <option v-for="sub in subsectors" :key="sub.id" :value="sub.id">{{ sub.description }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label
                        for="grouptype" class="form-label">Group</label></div>
                    <div class="col-md-9 input-right">
                      <select class="form-select" v-model="groupTypeId" @change="checkAddNewSubsector" required>
                        <option value="" disabled>- Select Group -</option>
                        <option v-for="group in groupTypes" :key="group.id" :value="group.id">{{ group.description }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-center">
                  <button class="submit-btn" type="submit" :disabled="isLoading">
                    <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {{ isLoading ? 'Submitting...' : 'Submit' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

  </DashboardLayout>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import Cookies from 'js-cookie';
import DashboardLayout from '../layout/DashboardLayout.vue'
import Swal from 'sweetalert2'

const root_api_url = process.env.VUE_APP_API_ROOT_URL

const isLoading = ref(false);

const mdaName = ref('');
const organizationCode = ref('');
const subSectorId = ref('');
const groupTypeId = ref('');
const subsectors = ref([])
const fetchSubSectors = async () => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/sub-sector`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    subsectors.value = response.data.map(subsectors => ({
      id: subsectors.id,
      sector: subsectors.sector,
      description: subsectors.description
    })).sort((a, b) => a.description.localeCompare(b.description))
  } catch (error) {
    console.error('Failed to fetch subsectors:', error)
  }
}

const groupTypes = ref([])
const fetchGroupTypes = async () => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/group-type`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    groupTypes.value = response.data.map(groupType => ({
      id: groupType.id,
      description: groupType.name
    })).sort((a, b) => a.description.localeCompare(b.description))
  } catch (error) {
    console.error('Failed to fetch group types:', error)
  }
}

const handleSubmit = async () => {

  const token = Cookies.get('auth_token');

  const MdaData = {
    name: mdaName.value.trim(),
    orgCode: organizationCode.value.trim(),
    subSectorId: subSectorId.value.trim(),
    groupTypeId: groupTypeId.value.trim(),
  };

  // console.log('MDA Data:', MdaData);
  isLoading.value = true;

  const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

  try {

    const result = await axios.post(`${root_api_url}/eli/mda`, MdaData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (result.status === 201) {
      Swal.fire({
        // title: 'Success!',
        html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>MDA Created Successfully</p> `,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
      // alert(`MDA Created Successfully`)
      mdaName.value = ''
      organizationCode.value = ''
      subSectorId.value = ''
      groupTypeId.value = ''
    }
  } catch (error) {
    // console.error('Submission error:', err)
    // alert('Failed to create MDA: ' + (err.response?.data?.message || err.message))
    // Swal.fire({
    //   html: `${iconHtmlError}
    //   <h1 style="font-weight:600;">Error</h1>
    //   <p>Failed to create MDA</p>`,
    //   showConfirmButton: true,
    //   showCloseButton: true,
    //   icon: undefined,
    // });

    if (error.response) {
      Swal.fire({
        html: `${iconHtmlError}
      <h1 style="font-weight:600;">Error</h1>
      <p>${error?.response?.data?.errorMessage || error?.response?.data?.error || 'Unexpected error occurred while creating MDA. Kindly contact administrator'}</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    } else {
      Swal.fire({
        html: `${iconHtmlError}
      <h1 style="font-weight:600;">Error</h1>
      <p>Unexpected error occurred while creating MDA. Kindly contact administrator</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    }

  } finally {
    isLoading.value = false;
  }
}

// On mount, load sectors and subsectors
onMounted(() => {
  fetchSubSectors(),
    fetchGroupTypes(),
    document.title = "Create MDA"
})
</script>
